module.exports = __webpack_public_path__ + "img/window.6eb43a85.svg";